export { DDRLactatingMother3150Strategy } from './ddr-lactating-mother-31-50.strategy';
export { DDRLactatingMother1930Strategy } from './ddr-lactating-mother-19-30.strategy';
export { DDRLactatingMother18Strategy } from './ddr-lactating-mother-18.strategy';
export { DDRPregnant3150Strategy } from './ddr-pregnant-31-50.strategy';
export { DDRPregnant1930Strategy } from './ddr-pregnant-19-30.strategy';
export { DDRPregnant18Strategy } from './ddr-pregnant-18.strategy';

export { DDRMen913Strategy } from './ddr-men-9-13.strategy';
export { DDRMen1418Strategy } from './ddr-men-14-18.strategy';
export { DDRMen1930Strategy } from './ddr-men-19-30.strategy';
export { DDRMen3150Strategy } from './ddr-men-31-50.strategy';
export { DDRMen5170Strategy } from './ddr-men-51-70.strategy';
export { DDRMen70Strategy } from './ddr-men-70.strategy';

export { DDRWoman913Strategy } from './ddr-woman-9-13.strategy';
export { DDRWoman1418Strategy } from './ddr-woman-14-18.strategy';
export { DDRWoman1930Strategy } from './ddr-woman-19-30.strategy';
export { DDRWoman3150Strategy } from './ddr-woman-31-50.strategy';
export { DDRWoman5170Strategy } from './ddr-woman-51-70.strategy';
export { DDRWoman70Strategy } from './ddr-woman-70.strategy';

